namespace com.enirva.util
{
	/*
	 * ユーザーエージェントクラス
	 */
	export class CSSUtil
	{
		/*
		 * スタイルを一括適用する
		 */
		public static applyStyle(target:JQuery, styles:Object):void
		{
			for (var prop in styles)
			{
				if (prop == "customAutoWidth")
				{
					target.css("width", "auto");
					//console.log(">> " + target.width());
					target.css("width", target.width());
				}
				else
				{
					target.css(prop, styles[prop]);
				}
			}
		}
	}
}

